import { render } from "./AddShopSubProduct.vue?vue&type=template&id=df40674a"
import script from "./AddShopSubProduct.vue?vue&type=script&lang=js"
export * from "./AddShopSubProduct.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__